import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { getStrandDisplayValue } from "./StrandCell.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";

const StrandListCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const strands: string[] = props.value;

  const items: ListCellItem[] = strands.map((strand: string) => ({
    value: getStrandDisplayValue(strand),
    tooltip: strand,
  }));

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export default StrandListCell;
